import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "basis-[50%] font-gordita-medium text-[16px] text-Text/text_high" }
const _hoisted_2 = { class: "flex-grow font-gordita-regular text-[13px] text-Text/text_high" }

import { computed } from 'vue';
import dashboardNoData from '@/views/dashboard/components/dashboard-no-data.vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';


export default /*#__PURE__*/_defineComponent({
  __name: 'build-duration-percentile-list',
  setup(__props) {

const dashboard = useDashboard();
const list = dashboard.workloads.buildDurationPercentileChart;

const hasData = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { __typename, ...percentile } = dashboard.gql.workloadsQuery.result.value?.workloads?.workloadsDurationPercentile ?? {};
  return percentile && Object.values(percentile).some(value => !!value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid flex-grow flex-col", {
      'm-auto': !_unref(hasData),
      'bg-Border/border_natural': _unref(hasData),
    }])
  }, [
    (!_unref(hasData))
      ? (_openBlock(), _createBlock(dashboardNoData, {
          key: 0,
          card: false,
          icon: "no_data",
          title: "No Data",
          subtitle: "This view requires at least 100 builds"
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(list), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.key,
            class: _normalizeClass(["flex justify-between items-center bg-System/app_white", {
        'border-b border-Border/border_natural': index !== _unref(list).length - 1,
      }])
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(item.key), 1),
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.value), 1)
          ], 2))
        }), 128))
  ], 2))
}
}

})